module.exports = __webpack_public_path__ + "img/ljdk_zhCn.4c85ffc0.png";